// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"a10a3f92e9--tooltip--fEi5K","title":"a10a3f92e9--title--jOxbB"};